"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExcursionRatesForDate = void 0;
const dayjs = require("dayjs");
const cloneObject_1 = require("../cloneObject");
const getExcursionRatesForDate = (date, rates, number_of_people) => {
    const rates_obj = (0, cloneObject_1.cloneObject)(rates);
    let has_future_rates = false;
    let has_current_or_future_rates = false;
    let has_had_rates = false;
    let has_current_rates = false;
    let filtered_rates = (0, cloneObject_1.cloneObject)(rates);
    // Find out if there are any future rates
    has_current_or_future_rates = rates.some((rate) => {
        // is today between the start and end date of the rate?
        if (dayjs(rate.start_date).isAfter(dayjs(date)))
            return true;
        if (dayjs(date).isSameOrAfter(dayjs(rate.start_date)) &&
            dayjs(date).isSameOrBefore(dayjs(rate.end_date)))
            return true;
        return false;
    });
    // Find out if there are any future rates
    has_future_rates = rates.some((rate) => {
        // is today between the start and end date of the rate?
        if (dayjs(rate.start_date).isAfter(dayjs(date)))
            return true;
        return false;
    });
    // Find out if there are any rates at all
    if (rates.length > 0) {
        has_had_rates = true;
    }
    // if there are no rates, return NO_RATES_EVER
    if (rates_obj.length === 0) {
        return {
            rates: [],
            closure: false,
            message: "NO_RATES_EVER",
        };
    }
    // filter out the historical rates
    filtered_rates = filtered_rates.filter((rate) => {
        // is today between the start and end date of the rate?
        if (dayjs(date).isAfter(dayjs(rate.end_date)))
            return false;
        return true;
    });
    if (filtered_rates.length === 0) {
        return {
            rates: [],
            closure: false,
            message: "NO_CURRENT_RATES",
        };
    }
    filtered_rates = filtered_rates.filter((rate) => {
        if (number_of_people < rate.min_pax) {
            return false;
        }
        return true;
    });
    if (filtered_rates.length === 0) {
        return {
            rates: [],
            closure: false,
            message: "INVALID_NUMBER_OF_PEOPLE_TODAY",
        };
    }
    // does the date fall between the start and end date of a rate
    has_current_rates = filtered_rates.some((rate) => {
        // does the date fall between the start and end dates (inclusive) of the rate?
        if (dayjs(date).isSameOrAfter(dayjs(rate.start_date)) &&
            dayjs(date).isSameOrBefore(dayjs(rate.end_date)))
            return true;
        return false;
    });
    if (!has_current_rates && has_future_rates) {
        return {
            rates: [],
            closure: false,
            message: "NO_CURRENT_RATES_HAS_FUTURE_RATES",
        };
    }
    // CHECK RATES ARE AVAILABLE FOR THE CURRENT DATE (NOT A CLOSURE)
    filtered_rates = filtered_rates.filter((rate) => {
        // filter out the rates where the course days of operation do not include the day of the date
        const day = dayjs(date).format("ddd");
        if (!day)
            return false;
        const key = day.toLowerCase();
        if (!rate.availability_days[key]) {
            return false;
        }
        return true;
    });
    if (filtered_rates.length === 0) {
        return {
            rates: [],
            closure: false,
            message: "RATE_AVAILABLE_DAYS_CLOSURE",
        };
    }
    // does the date fall between the start and end date of the rate?
    filtered_rates = filtered_rates.filter((rate) => {
        if (dayjs(date).isBefore(dayjs(rate.start_date)))
            return false;
        if (dayjs(date).isAfter(dayjs(rate.end_date)))
            return false;
        return true;
    });
    // Group the rates
    const grouped_rates = filtered_rates.reduce((r, a) => {
        r[`${a.excursion_id}_${a.variation_id}_${a.min_pax}_${a.max_pax}`] = [
            ...(r[`${a.excursion_id}_${a.variation_id}_${a.min_pax}_${a.max_pax}`] ||
                []),
            a,
        ];
        return r;
    }, {});
    // Sort the rates
    const sorted_rates = Object.keys(grouped_rates)
        .map((key) => {
        // group and sort them to get the cheapest rate
        return grouped_rates[key].sort((a, b) => Number(a.sell_price) - Number(b.sell_price))[0];
    })
        .sort((a, b) => Number(a.sell_price) - Number(b.sell_price));
    if (sorted_rates.length === 0) {
        return {
            rates: [],
            closure: false,
            message: "NO_RATES",
        };
    }
    return {
        rates: sorted_rates,
        closure: false,
        message: "RATES_FOUND",
    };
};
exports.getExcursionRatesForDate = getExcursionRatesForDate;
